import * as z from "zod";

const GetLoopSyncStatusInputSchema_ = z.object({ teamId: z.string() });

export const GetLoopSyncStatusInputSchema: z.ZodType<GetLoopSyncStatusInput> =
  GetLoopSyncStatusInputSchema_;
export interface GetLoopSyncStatusInput
  extends z.infer<typeof GetLoopSyncStatusInputSchema_> {}

const GetLoopSyncStatusOutputSchema_ = z.object({
  configured: z.boolean(),
  // If configured, these fields are present
  syncInProgress: z.boolean().optional(),
  stopAt: z.string().optional(), // ISO date string
  current: z.string().optional(), // ISO date string
});

export const GetLoopSyncStatusOutputSchema: z.ZodType<GetLoopSyncStatusOutput> =
  GetLoopSyncStatusOutputSchema_;
export interface GetLoopSyncStatusOutput
  extends z.infer<typeof GetLoopSyncStatusOutputSchema_> {}

export const getLoopSyncStatus = {
  name: "getLoopSyncStatus" as const,
  input: GetLoopSyncStatusInputSchema,
  output: GetLoopSyncStatusOutputSchema,
};
